/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlannerSessionResponse } from './PlannerSessionResponse';
import {
    PlannerSessionResponseFromJSON,
    PlannerSessionResponseFromJSONTyped,
    PlannerSessionResponseToJSON,
    PlannerSessionResponseToJSONTyped,
} from './PlannerSessionResponse';

/**
 * 
 * @export
 * @interface PlannerSessionListResponse
 */
export interface PlannerSessionListResponse {
    /**
     * 
     * @type {Array<PlannerSessionResponse>}
     * @memberof PlannerSessionListResponse
     */
    sessions: Array<PlannerSessionResponse>;
}

/**
 * Check if a given object implements the PlannerSessionListResponse interface.
 */
export function instanceOfPlannerSessionListResponse(value: object): value is PlannerSessionListResponse {
    if (!('sessions' in value) || value['sessions'] === undefined) return false;
    return true;
}

export function PlannerSessionListResponseFromJSON(json: any): PlannerSessionListResponse {
    return PlannerSessionListResponseFromJSONTyped(json, false);
}

export function PlannerSessionListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlannerSessionListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'sessions': ((json['sessions'] as Array<any>).map(PlannerSessionResponseFromJSON)),
    };
}

export function PlannerSessionListResponseToJSON(json: any): PlannerSessionListResponse {
    return PlannerSessionListResponseToJSONTyped(json, false);
}

export function PlannerSessionListResponseToJSONTyped(value?: PlannerSessionListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sessions': ((value['sessions'] as Array<any>).map(PlannerSessionResponseToJSON)),
    };
}

